import * as React from "react";
import {
  EditComponent,
  CreateComponent,
  CustomComponentProps,
} from "src/components/common/Component";
import { Button } from "react-admin";
import SubjectIcon from "@mui/icons-material/Subject";
import { useRecordContext, useResourceContext, useCreatePath } from 'ra-core';
import { Link } from 'react-router-dom';

export function NavigationEditComponent(props: CustomComponentProps) {
  const { children } = props;
  return <EditComponent attributes={["name"]} children={children} />;
}

export function NavigationCreateComponent(props: CustomComponentProps) {
  const { children } = props;
  return <CreateComponent source={"navigation"} children={children} />;
}

export function ItemsButton(props) {
    const { id, ...rest } = props;
    const createPath = useCreatePath();
    const record = useRecordContext(props);
    const resource = useResourceContext(props);

    return (
        <Button
          component={Link}
          variant="text"
          color="primary"
          size="small"
          to={createPath({ type: 'edit', resource: `${resource}/${record.id}/items`})}
          label="Items"
          startIcon={<SubjectIcon />}
          onClick={e => e.stopPropagation()}
          {...rest}
        />
    );
};